import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemHomeSecondaryV2 } from "scmp-app/components/content/content-item-render/variants/home-secondary-v2";
import {
  ActionBar as SecondaryActionBar,
  CoverImage as SecondaryCoverImage,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { SeriesShortLabelLink } from "scmp-app/components/content/content-series-short-label/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }
`;

export const StyledContentItemHomeSecondary = styled(ContentItemHomeSecondaryV2)`
  column-gap: 16px;

  ${theme.breakpoints.only("mobile")} {
    grid:
      "header cover-image" min-content
      "headline cover-image" min-content
      "action-bar cover-image" min-content
      / auto 144px;

    :not(:first-of-type) {
      margin-block-start: 12px;
      padding-block-start: 20px;
      border-block-start: 1px solid #000000;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    flex: 1 1 calc(100% - 20px);
    grid:
      "header cover-image" min-content
      "headline cover-image" min-content
      "subHeadline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      ". cover-image" minmax(0, 1fr)
      / auto 144px;
    column-gap: 12px;

    :first-of-type {
      flex: 1 1 100%;

      margin-inline-end: 20px;
      padding-inline-end: 20px;
      border-inline-end: 1px solid #dfdfdf;
    }
  }

  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
  }

  ${SeriesShortLabelLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
  }

  ${SecondaryActionBar} time {
    color: #727272;
    font-size: 11px;
  }

  ${SecondaryCoverImage} {
    inline-size: 144px;
    margin: 0;
  }
`;
